import React from 'react'
import FooterLeft from './FooterLeft'
import FooterLegals from './FooterLegals'
// import FooterRight from './FooterRight';

const Footer = () =>(
	<footer>
	<div className="footer-container">
		<div className="footer">

			<div className="footer-redes">
				<FooterLeft />
			</div>

			<div className="footer-mapa">
				<section className="footer_boxes">
					<div className="footer_boxes-box">
						<h4>Mapa del sitio</h4>
						<ul className="footer_boxes-nav">
								<li><a href="/">Inicio</a></li>
								<li><a href="/canales">Canales</a></li>
								<li><a href="/guia">Guía</a></li>
								<li><a href="/cartelera">Cartelera</a></li>
								<li><a href="/planes">Planes</a></li>
								<li><a href="/dispositivos">Dispositivos</a></li>
								<li><a href="/ayuda">Ayuda</a></li>
								<li><a href="/planes#giftAnchor">Gift Cards</a></li>
						</ul>
					</div>
				</section>
			</div>

			<div className="footer-contacto">
				<div className="footer_boxes-box">
					<h4>Contáctanos</h4>
					<p><b>Correo electrónico</b> <br />
					info@digital.com.bo</p>
					<p><b>Teléfono</b> <br />
					<a href="tel:591-3363-5555" className="linkPhones">(591-3) 363-5555)</a></p>
					<p><b>Whatsapp</b> <br />
					<a href="https://wa.me/59169010100" target="blank" className="linkPhones">(591-6) 901-0100)</a></p>
				</div>
			</div>

			<div className="footer-direcciones">
				<div className="footer_boxes-box">
					<h4>Direcciones</h4>
					<p><b>Casa central</b> <br />
					Av Irala #616, Santa Cruz.</p>
					<p><b>Horarios de atención</b> <br />
					Lunes a viernes de 08:00 a 18:00hs.<br /> <br />
					Sábados de 08:00 a 12:30hs.</p> 
				</div>
			</div>
		</div>
	</div>
	<div className="footer__legals">
			<FooterLegals />
	</div>
	<a href='' className="chatbot"></a>
	</footer>
)

export default Footer;